import { MaterialType } from "../../carrier/carrier-enum";
import { LabMDM } from "../../masterdata/models/lab";
import { ContainerItemAware } from "./containerItem-aware";

export class Material extends ContainerItemAware {
   
    type: MaterialType;
    barcode: string;
    originalVolume: number;
    remainingVolume: number;
    orderItemId: string;
    lab: LabMDM;
    isAliquot:boolean;
}